angular.module("app").directive('reflectionView', function($document,$timeout) {
	return {
	  restrict: 'A',
	  templateUrl: 'views/reflection.html?version=1.0',

	  link:function($scope,element,attr)
	  {
	    var trace = angular.trace;
	  }  
	};
});

angular.module("app").directive('reflectionLandingView', function($document,$timeout) {
	return {
	  restrict: 'A',
	  templateUrl: 'views/reflection-landing.html?version=1.0',

	  link:function($scope,element,attr)
	  {
	    var trace = angular.trace;
	  }  
	};
});


angular.module("app").directive('reflectionQuestionView', function($document,$timeout) {
	return {
	  restrict: 'A',
	  templateUrl: 'views/reflection-question.html?version=1.0',

	  link:function($scope,element,attr)
	  {
	    var trace = angular.trace;
	  }  
	};
});

angular.module("app").directive('reflectionFeedbackLandingView', function($document,$timeout) {
	return {
	  restrict: 'A',
	  templateUrl: 'views/reflection-feedback-landing.html?version=1.0',

	  link:function($scope,element,attr)
	  {
	    var trace = angular.trace;
	  }  
	};
});